import { connectSortBy } from "instantsearch.js/es/connectors/index.js";
import { columnState } from "../components/column-state.js";
import { columnConfigPopup } from "../components/column-config-popup.js";

const getSortDirection = (col, currentRefinement) => {
  if (currentRefinement === col.ascIndex) {
    return "asc";
  }

  if (currentRefinement === col.descIndex) {
    return "desc";
  }

  return "";
};

const getNextSortIndex = (col, currentRefinement) => {
  if (!col.ascIndex || !col.descIndex) {
    return null;
  }

  return currentRefinement === col.ascIndex ? col.descIndex : col.ascIndex;
};

const createProductsSortByWidget = () => {
  let unsubscribeColumnState = null;
  let latestRenderOptions = null;

  const render = (renderOptions, isFirstRender) => {
    const { currentRefinement, refine, widgetParams } = renderOptions;
    let { container, columns = [] } = widgetParams;

    latestRenderOptions = renderOptions;

    // Subscribe to column state changes on first render
    if (isFirstRender && !unsubscribeColumnState) {
      unsubscribeColumnState = columnState.subscribe((newColumns) => {
        if (newColumns.length > 0) {
          const nextRenderOptions = latestRenderOptions || renderOptions;

          nextRenderOptions.widgetParams.columns = newColumns;
          renderHeader(
            nextRenderOptions.widgetParams.container,
            newColumns,
            nextRenderOptions.currentRefinement,
            nextRenderOptions.refine
          );
        }
      });
    }

    // Always check columnState - it may have been updated by middleware
    const stateColumns = columnState.getColumns();
    if (stateColumns.length > 0) {
      columns = stateColumns;
      widgetParams.columns = stateColumns;
    }

    renderHeader(container, columns, currentRefinement, refine);
  };

  const unmount = () => {
    if (unsubscribeColumnState) {
      unsubscribeColumnState();
      unsubscribeColumnState = null;
    }

    latestRenderOptions = null;
  };

  return connectSortBy(render, unmount);
};

export const chamfrProductsSortBy = (widgetParams) =>
  createProductsSortByWidget()(widgetParams);

function renderHeader(container, columns, currentRefinement, refine) {
  // Build header HTML
  const headerHTML =
    columns
      .map((col, index) => {
        const sortDirection = getSortDirection(col, currentRefinement);
        const arrowClass = ["arrow", sortDirection].filter(Boolean).join(" ");
        const classes = [col.key];

        if (col.ascIndex && col.descIndex) {
          classes.push("sortable");
        }

        if (sortDirection) {
          classes.push("sort");

          classes.push(sortDirection === "asc" ? "sort-asc" : "sort-desc");
        }

        return `
        <th class="${classes.join(" ")}"><a href="javascript:void(0);"
           data-index="${index}">
          ${col.label} ${col.ascIndex ? `<span class="${arrowClass}"></span>` : ""}
        </a></th>`;
      })
      .join("") +
    `<th class="item-description"></th><th class="actions">
      <span class="has-beta-sup chamfr-column-config-wrapper">
        <a href="javascript:void(0);" class="chamfr-column-config-link" title="Configure columns">Edit Columns</a>
      </span>
      <span class="chamfr-beta-tooltip-anchor">
        <span class="chamfr-beta-trigger" aria-label="More information">&#8505;</span>
        <span class="chamfr-beta-tooltip">
          <strong>Customize your columns</strong>
          Add, remove, or reorder attributes to compare products and sort results your way.
          <a href="/blog/dynamic-columns-product-category/" target="_blank" rel="noopener noreferrer">Watch how it works →</a>
        </span>
      </span>
    </th>`;

  container.innerHTML = headerHTML;

  // Bind config link
  const configLink = container.querySelector(".chamfr-column-config-link");
  if (configLink) {
    // Remove previous handler
    const newConfigLink = configLink.cloneNode(true);
    configLink.replaceWith(newConfigLink);

    newConfigLink.addEventListener("click", (e) => {
      e.preventDefault();
      const category = columnState.getCurrentCategory();
      columnConfigPopup.open(category, columns, () => {
        // Refresh will be handled by middleware
      });
    });
  }

  // Bind the click handlers for sorting
  const columnLinks = container.querySelectorAll("th a:not(.chamfr-column-config-link)");

  columnLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();

      const colIndex = parseInt(link.dataset.index, 10);
      if (isNaN(colIndex) || !columns[colIndex]) return;

      const newSort = getNextSortIndex(columns[colIndex], currentRefinement);

      if (newSort) {
        refine(newSort);
      }
    });
  });
}
